import { render, staticRenderFns } from "./HeaderHome.vue?vue&type=template&id=5fe336f8"
import script from "./HeaderHome.vue?vue&type=script&lang=js"
export * from "./HeaderHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SearchInput: require('/opt/build/repo/components/SearchInput.vue').default,BrandListMinimal: require('/opt/build/repo/components/brand/ListMinimal.vue').default,SectionBase: require('/opt/build/repo/components/section/Base.vue').default})
